import TagManager from 'react-gtm-module';
import { PromoDetails } from './types';

const eePromoClickHandler = (promoDetails: PromoDetails) => {
  const {
    id,
    name,
    type,
    url,
    position,
    isVideo,
    'co-op_brand_attribute': coOpBrandAttribute,
  } = promoDetails;
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object
  TagManager.dataLayer({
    dataLayer: {
      event: 'ee promo click',
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id,
              name,
              creative: [type, url],
              position,
              isVideo: isVideo ? true : false,
              coop_brand: coOpBrandAttribute,
            },
          ],
        },
      },
    },
  });
};

export default eePromoClickHandler;
